/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { IntegConfig } from '../models/IntegConfig';
import { IntegType } from '../models/IntegType';

/**
* Integration configuration and metadata
*/
export class IntegrationConfig {
  'id': string;
  'projectId'?: string;
  'name': string;
  'enabled'?: boolean;
  'type': IntegType;
  'config'?: IntegConfig;
  'dateCreated'?: Date;
  'dateModified'?: Date;
  'userCreated'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "projectId",
      "baseName": "projectId",
      "type": "string",
      "format": "uuid"
    },
    {
      "name": "name",
      "baseName": "name",
      "type": "string",
      "format": ""
    },
    {
      "name": "enabled",
      "baseName": "enabled",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "type",
      "baseName": "type",
      "type": "IntegType",
      "format": ""
    },
    {
      "name": "config",
      "baseName": "config",
      "type": "IntegConfig",
      "format": ""
    },
    {
      "name": "dateCreated",
      "baseName": "dateCreated",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "dateModified",
      "baseName": "dateModified",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "userCreated",
      "baseName": "userCreated",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return IntegrationConfig.attributeTypeMap;
  }

  public constructor() {
  }
}



